import { createDocument, type ZodOpenApiPathsObject } from 'zod-openapi';
import { auditPaths } from './audit.js';
import { cataloguePaths } from './catalogue.js';
import { customerPaths } from './customers.js';
import { integrationPaths } from './event-catalogue.js';
import { identityPaths } from './identity.js';
import { loyaltyPaths } from './loyalty.js';
import { orderPaths } from './orders.js';
import { paymentPaths } from './payments.js';
import { pricingPaths } from './pricing.js';
import { settingsPaths } from './settings.js';
import { systemPaths } from './system.js';

/** Every module adds its paths here; this object is the single source of the HTTP contract. */
export const apiPaths: ZodOpenApiPathsObject = {
  ...systemPaths,
  ...identityPaths,
  ...auditPaths,
  ...settingsPaths,
  ...integrationPaths,
  ...cataloguePaths,
  ...customerPaths,
  ...pricingPaths,
  ...orderPaths,
  ...paymentPaths,
  ...loyaltyPaths,
};

export function buildOpenApiDocument(): ReturnType<typeof createDocument> {
  return createDocument({
    openapi: '3.1.0',
    info: { title: 'DeliCRM API', version: '1' },
    paths: apiPaths,
  });
}
